import { functions } from '@/assets/script/functions'
import search from '@/helpers/searchHelper'
import recipeHelper from '@/helpers/recipeHelper'

const currentCategory = {
  state: {
    currentCategory: {
      categories: [],
      Recipes: [],
      FilteredRecipes: [],
      OrderBy: 'new',
      Name: ''
    },
    SearchString: '',
    search: [],
    nrOfRecipesToShow: 21
  },
  mutations:{
    setCategoriesState(state, categories){
      state.currentCategory.categories = categories.sort()
    },
    setCategoryRecipesState(state, recipes){
      state.currentCategory.Recipes = recipes
    },
    setFilteredRecipesState(state, recipes){
      state.currentCategory.FilteredRecipes = recipes
    },
    setCategoryName(state, value){
      state.currentCategory.Name = value
    },
    setNrOfRecipesToShow(state, amount){
      state.nrOfRecipesToShow = amount
    },
    setOrderBy(state, value){
      state.currentCategory.OrderBy = value
    },
    setSearch(state, value){
      state.search = value
    },
    setSearchString(state, value){
      state.SearchString = value
    }
  },
  actions: {
    // Called on category load
    setCurrentCategory({commit, getters, dispatch}, categoryName){
      let uniqueCategories
      if(categoryName == 'Søk'){
        uniqueCategories = []
        if(getters.nrOfRecipesToShow == 21)
          commit('setNrOfRecipesToShow', 20)
        commit('setCategoryRecipesState', getters.allRecipes)
      }else{
        const categoryData = getters.sortedCategories.find(category =>  category.name == categoryName)
        uniqueCategories = functions.getUnique(categoryData.categories, 'name').map(category => {
          return category.name
        })
        const category = getters.sortedCategories.find(category => category.name == categoryName)
        const recipes = category.categories.map(category => category.recipe)
        commit('setCategoryRecipesState', recipes)
      }
      commit('setTitle', categoryName)
      commit('setCategoryName', categoryName)
      commit('setCategoriesState', uniqueCategories)
      dispatch('setFilteredRecipes')
    },
    // Set filtered recipes to match selected sub/categories
    setFilteredRecipes({dispatch, getters}){
      let recipes;
      if(getters.selectedMainCategories.length == 0 && getters.selectedSubCategories.length == 0){
        recipes = getters.currentCategory.Recipes
      }
      else{
        recipes = getters.currentCategory.Recipes.filter(recipe => {
          const filteredcat = getters.selectedMainCategories.filter(category => {
            return recipe.Categories.map(c => c.Name).indexOf(category) != -1;
          })
          const filteredsub = getters.selectedSubCategories.filter(category => {
            return recipe.Categories.map(c => c.Name).indexOf(category) != -1;
          })
          if (filteredcat.length + filteredsub.length == getters.selectedMainCategories.length + getters.selectedSubCategories.length)
            return true
        })
      }
      dispatch('getSubCategories', recipes)
      dispatch('applyOrder', functions.getUnique(recipes, 'Title'))
    },

    applyOrder({state, commit}, recipes){
      if(state.search.length > 0)
        recipes = search.search(state.search, recipes)
      const orderedRecipes = recipeHelper.orderRecipeBy(recipes, state.currentCategory.OrderBy)
      commit('setFilteredRecipesState', orderedRecipes)
    },
  },
  getters: {
    filteredRecipes: state => state.currentCategory.FilteredRecipes,
    nrOfRecipesToShow: state => state.nrOfRecipesToShow,
    currentCategory: state => state.currentCategory,
    orderBy: state => state.currentCategory.OrderBy,
    searchString: state => state.SearchString
  }
}
export default currentCategory